$(".dropdown").on("click", ".dropdown__link", function (e) {
    e.preventDefault();
    e.stopPropagation();
    $(this).next('.dropdown__content').toggleClass("js-active");
});